(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-triss.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-triss.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
class RowTriss extends svs.tur.ball.row.Default {
  constructor(_ref) {
    let _ref$tickets = _ref.tickets,
      tickets = _ref$tickets === void 0 ? [] : _ref$tickets,
      description = _ref.description,
      order = _ref.order;
    super({
      numbers: tickets,
      description,
      order,
      BallClass: svs.tur.ball.Triss
    });
    this._numbers = tickets;
    this._huxfluxPrepared = true;
  }
  createDomElements() {
    this.$inner = this.createElement('inner');
    this.$text = this.createElement('text');
    this.$text.innerHTML = "<span class=\"f-medium\">".concat(this.description.title, "</span> ").concat(this.description.description);
    this.$inner.appendChild(this.$text);
    this.$ballsRegular = this.createElement('tickets');
    this.$inner.appendChild(this.$ballsRegular);
    this.$header = this.createElement('header');
    this.$header.innerHTML = svs.ui.brands.partials.brands({
      brand: 'triss'
    });
    this.$el.appendChild(this.$header);
    this.$el.appendChild(this.$inner);
  }
  classNames() {
    return ['ball-row-triss'];
  }
}
svs.tur.ball.row.Triss = RowTriss;

 })(window);